import script from "./trade.vue?vue&type=script&setup=true&lang=ts"
export * from "./trade.vue?vue&type=script&setup=true&lang=ts"

import "./trade.vue?vue&type=style&index=0&id=07112495&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07112495"]])

export default __exports__